import type { Entity, World } from 'koota';
import { raycastClosest } from '../physics/queries';
import { heldWeaponAnchor, weaponMuzzle, weaponPoint, weaponShoulder, type WeaponAnchor } from './geometry';
import type { WeaponDef } from './schema';

/** Fold a long barrel back before a wall instead of letting it fire through the far side. */
export function resolveWeaponAnchor(
  world: World,
  owner: Entity,
  def: WeaponDef,
  pose: Parameters<typeof heldWeaponAnchor>[0],
): WeaponAnchor {
  const anchor = heldWeaponAnchor(pose);
  if (def.projectile.kind === 'melee') return anchor;
  const shoulder = weaponShoulder(pose);
  const muzzle = weaponPoint(weaponMuzzle(def.shape.kind, def.shape.length), anchor);
  const wall = raycastClosest(world, shoulder.x, shoulder.y, muzzle.x, muzzle.y, (hit) => hit.entity === owner || (hit.kind !== 'solid' && hit.kind !== 'prop'));
  if (!wall) return anchor;
  return { ...anchor, x: anchor.x + wall.x + wall.nx * 0.025 - muzzle.x, y: anchor.y + wall.y + wall.ny * 0.025 - muzzle.y };
}
